// extracted by mini-css-extract-plugin
export default {"selectedSession":"SessionExtra_selectedSession__qj2lM","infoWrapper":"SessionExtra_infoWrapper__bkUUc"};